import React, { useState } from 'react'
import { useLocation } from "react-router-dom";
import moment from 'moment'



const OrderedTickets = () => {
    const location = useLocation();
    const reservations = location.state.reservations

   // console.log(reservations, 'reservations')
    let future_order = []
    let past_order = []

    reservations &&  reservations.map((item) => {
        let id = moment(item.ArrDate).format('YYYY-MM-DD')
        let td = moment().format('YYYY-MM-DD')

        if (moment(id).isSameOrAfter(moment(td)) && item.Enabled === 1) {

            future_order.push(item)
        }
        else past_order.push(item)
    })

   
    return (
        <main>
            <p className='text'>Bestilte billetter</p>

            {future_order.length ? future_order.map(item => {
                return <div className='ticketContainer'>
                    <img className='movie-img' src={`https://poster.ebillet.dk/${item.Poster}`} />
                    <div className='info-container'>
                        <p className='ticket-text' >Bestilte billetter til</p>
                        <p className='movie-name'>{item.ArrName}</p>
                        <p className='undertext'>med dansk tekster</p>
                        <br></br>
                        <p className='movie-info'> <span>Biograf:</span> <label>{item.OrgName}</label>  </p>
                        <p className='movie-info'> <span>Dato:</span> <label>{moment(item.ArrDate).format('DD')}.{moment(item.ArrDate).locale('da').format(' MMMM')}{moment(item.ArrDate).format(' YYYY')}</label>  </p>
                        <p className='movie-info'> <span>Tidspunkt:</span> <label>{moment(item.ArrDate).format('LT')}</label>  </p>
                        <p className='movie-info'> <span>Sal:</span> <label>{item.LocationName}</label>  </p>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '-15px' }}>
                            <p className='movie-info'> <span>Placering:</span> <label>{item.PlacementNice}</label>  </p>
                            <button className='buyticket'>Køb bestilte billetter</button>

                        </div>

                    </div>
                </div>
            }) : null} 
           
         

            {past_order.length && <div className='past-text-container'> <p className='past-ticket-text'>Tidligere bestilte billetter</p>
            </div>}


            <div className='past-tickets-container' >
                {past_order.length && past_order.map(item => {

                    return <div style={{ display: 'flex', }}>
                        <img width='105px' height='154px' src={`https://poster.ebillet.dk/${item.Poster}`} />
                        <div style={{ width: '300px', padding: '0px 30px' }}>
                            <p className='movie-name'>{item.ArrName}</p>
                        </div>
                    </div>


                })}
            </div>
          
           
        </main>
    )
}

export default OrderedTickets